import { Routes } from '@angular/router';
import { SiaActionsManagerPageComponent } from './pages/sia-actions-manager-page/sia-actions-manager-page.component';

export const ROUTES: Routes = [
  {
    path: 'actions-manager/:guid',
    component: SiaActionsManagerPageComponent,
  },
];
